<app-base-entry-dialog-template [value]="value" [formGroupRef]="formGroupRef" [isSaving]="isSaving"
                                (saveClick)="onSaveClicked()" (cancelClick)="onCancelClicked()">
  <app-business-file-form
    [(formGroupRef)]="formGroupRef"
    [(fileList)]="fileList"
    [(value)]="value">
  </app-business-file-form>
</app-base-entry-dialog-template>
<app-blocking-loader *ngIf="showBlockingLoader"></app-blocking-loader>
